import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { DraftStep, KioskFlow, KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { getDraftError, toScreenFlow } from '../utils/flow-steps';
import { assertOperator, validateFlowName } from './flow-validation';

export class SaveKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  // Saves the step rows and the promo banner file name ('' = none) as the flow's draft
  async execute(
    ctx: KioskFlowOperatorContext,
    flow: KioskFlow,
    draft: DraftStep[],
    bannerFileName: string,
  ): Promise<KioskFlow> {
    assertOperator(ctx);
    const draftError = getDraftError(draft, bannerFileName);
    if (draftError) throw new Error(draftError);
    return this.repository.saveFlow(ctx, {
      name: validateFlowName(flow.name),
      promoBannerFileName: bannerFileName.trim() || null,
      screenFlow: toScreenFlow(draft),
    });
  }
}
